import React from 'react';
import styled from 'styled-components';
import { PlaceholderBlock } from '../../../styled/placeholders.styled';

import { Breakpoints } from '../../../styled/constants';

export const Breadcrumbs = styled.div`
  background-color: ${({ theme }) => theme.colors.background.primary};
  height: 37px;
  padding: 10px;

  @media (min-width: ${Breakpoints.tablet}px) {
    padding: 10px 40px;
  }

  @media screen and (min-width: ${Breakpoints.desktop}px) {
    height: 50px;
    padding: 16px 20px;
  }
`;

export const BreadcrumbsPlaceholder: React.FC = () => (
  <Breadcrumbs>
    <PlaceholderBlock height="18px" margin="0" />
  </Breadcrumbs>
);
